import HeroCarouselV1 from "./v1/HeroCarousel";
import { heroSlidesV1, HERO_CAROUSEL_IMAGE_SIZE } from "./v1/heroSlides";

export default HeroCarouselV1;
export { HeroCarouselV1, heroSlidesV1, HERO_CAROUSEL_IMAGE_SIZE };
